import { render, staticRenderFns } from "./createStatement.vue?vue&type=template&id=410bf148&scoped=true"
import script from "./createStatement.vue?vue&type=script&lang=js"
export * from "./createStatement.vue?vue&type=script&lang=js"
import style0 from "./createStatement.vue?vue&type=style&index=0&id=410bf148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410bf148",
  null
  
)

export default component.exports